import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['2,000 drills = 2,000 decisions', 'Plans written for high-school teams', 'Monthly fees, logins and videos that disappear', 'Drills that leave kids waiting in line', 'You still plan every practice the night before'];
const withIt = ['One complete practice per session, ready to run', 'Every plan split by age: U8–U10 and U12–U14', 'One payment, PDF files that stay yours', 'Pods of 3 per ball — every kid moving', 'Open it, print it, run it in 5 minutes'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-navy-deep" data-id="element-344" data-mp="297qp9g4d0y3i">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-345" data-mp="295e7b2ylqnqg">
        <div className="text-center" data-id="element-346" data-mp="2d799e9ocx55a">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-gold" data-id="element-347" data-mp="30yep8ouarxfl">
            Why this isn&apos;t another drill library
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-348" data-mp="35pwnh54xrjwv">
            A drill app vs <span className="text-gold" data-id="element-349" data-mp="1ogs5xpesw6ke">a planned season</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-350" data-mp="23566tusnpkyb">
            Everything out there competes on how many drills it has. More drills
            were never the problem — knowing what to run on Tuesday at 5:30 was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-navy-line" data-id="element-351" data-mp="284smeavyjdaa">
          <div className="bg-navy-card px-3.5 py-4 sm:p-6" data-id="element-352" data-mp="2m4k5gq1bzjv5">
            <h3 className="font-display text-base font-bold uppercase tracking-wide text-ink-soft sm:text-xl" data-id="element-353" data-mp="2m1xwclyskwat">
              A drill app subscription
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-354" data-mp="rqsof5go9xpo">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-355" data-mp="mry41z32413g">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-crimson/15" data-id="element-356" data-mp="2muqs2sciu7v5">
                    <XIcon className="h-2.5 w-2.5 text-crimson-deep" aria-hidden="true" data-id="element-357" data-mp="2ru3mby5q2h7r" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-turf/20 px-3.5 py-4 text-white sm:p-6" data-id="element-358" data-mp="35s1n20r4ef4s">
            <h3 className="font-display text-base font-bold uppercase tracking-wide text-gold sm:text-xl" data-id="element-359" data-mp="35rrv47milxwg">
              No-Lines Lacrosse
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-360" data-mp="3fhbi9ph9gdx4">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-361" data-mp="3jj6on8e1thhr">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-turf" data-id="element-362" data-mp="3ojb0gl40ho1n">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-363" data-mp="3tie4q3c63q8k" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}